'use strict';

export default class OPLResourcesSearch {
    constructor() {
        this.form = document.getElementById('opl-online-resources-search');
        this.azureSearchOptions = null;
        this.baseSearchFilter = null;
        this.searchSelector = null;
        this.searchTerm = null;
    }

    load(options) {
        this.azureSearchOptions = options;
        this.baseSearchFilter = options.searchParams.filter;
        this.setSearchData();
        if (window.OPL && window.OPL.AzureSearch) {
            window.OPL.AzureSearch.initAndRunSearch(options);
        }
    }

    submitSearch(event) {
        event.preventDefault();
        this.setSearchData();
        if (window.OPL && window.OPL.AzureSearch) {
            window.OPL.AzureSearch.initAndRunSearch(this.azureSearchOptions);
        }
    }

    resetSearch(event) {
        event.preventDefault();

        if (this.form) {
            // reset the fields manually
            [...this.form.elements].forEach(element => {
                if (element.type === 'radio' || element.type === 'checkbox') {
                    element.checked = false;
                } else if (element.type !== 'reset' && element.type !== 'submit') {
                    element.value = '';
                }
            });

            // set the all category to selected
            this.form.elements['resource-filter-all'].checked = true;
            // set the search params
            this.setSearchData();
            // get the results from the index
            if (window.OPL && window.OPL.AzureSearch) {
                window.OPL.AzureSearch.initAndRunSearch(this.azureSearchOptions);
            }
        }
    }

    setSearchData() {
        const data = new FormData(this.form);
        this.azureSearchOptions.searchParams.filter = this.baseSearchFilter;
        this.azureSearchOptions.searchParams.skip = 0;

        for (let field of data.entries()) {
            if (field[0] === 'searchterm') {
                this.searchTerm = field[1];
                this.azureSearchOptions.searchParams.search = field[1];
            } else {
                this.azureSearchOptions.searchParams.filter = this.setSearchFilter(field);
            }
        }
    }

    setSearchFilter(filter) {
        let filterText = this.baseSearchFilter;
        let filterVal = '';

        if (Array.isArray(filter) && filter.length > 0 && filter[1] !== '') {
            filterText += ` and (${filter[0]}/any(m: m eq '${filter[1]}'))`;
            filterVal = filter[1];
        }

        this.updateFilterHistory(filterVal);
        return filterText;
    }

    updateFilterHistory(filterValue) {
        const currentPath = window.location.pathname;
        const currentPathParts = currentPath.split('/');
        let newPathParts = [];
        let newPath = '/';

        // lets check for empty slots in the array,
        // for example if the last character in the path is a slash`/`
        currentPathParts.forEach((item) => {
            if (typeof item !== 'undefined' && item !== '' && item !== null) {
                newPathParts.push(item);
            }
        });

        // if the path has more than one item
        // lets remove the last one which would
        // be the active filter
        if (newPathParts.length > 1) {
            newPathParts.pop();
        }
        // add the new filter value
        // as the last item if it exists
        if (typeof filterValue !== 'undefined' && filterValue !== '' && filterValue !== null) {
            newPathParts.push(filterValue);
        }

        newPath += newPathParts.join('/') + '/';


        // push the new search query string to the browser history
        window.history.replaceState({ 'url': newPath }, '', newPath);
    }
}
